import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Epic%20Naruto%20anime%20fan%20art%20illustration%20with%20multiple%20characters%20in%20dynamic%20action%20poses%2C%20vibrant%20orange%20and%20warm%20colors%2C%20Konoha%20village%20background%20at%20sunset%2C%20dramatic%20lighting%2C%20cinematic%20wide%20composition%2C%20wind%20and%20leaves%20effects%2C%20emotional%20and%20inspiring%20atmosphere%2C%20professional%20anime%20art%20style&width=1800&height=1200&seq=hero-naruto-fan&orientation=landscape"
        alt="火影忍者同人创作"
        title="火影忍者同人创作指南"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      <div className="absolute inset-0 flex flex-col items-center justify-center px-4 text-center">
        <div className="w-full max-w-3xl">
          <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-white mb-4 md:mb-6 leading-tight">
            火影忍者同人——创作者必看的完整指南
          </h1>
          <p className="text-white/85 text-sm md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
            探索火影忍者同人的世界：原创剧情、人物重塑、CP配对、同人小说与插画创作技巧全解析。无论你是新手还是资深同人作者，这里汇聚最全面的火影忍者同人创作灵感与资源。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/chuangzuo-jiaocheng"
              className="whitespace-nowrap px-6 py-3 bg-primary-500 text-background-50 rounded-md font-medium text-sm hover:bg-primary-600 transition-colors duration-200"
            >
              开始创作之旅
            </Link>
            <Link
              to="/category/tongren-xiaoshuo"
              className="whitespace-nowrap px-6 py-3 bg-background-50/20 backdrop-blur-sm text-white border border-white/30 rounded-md font-medium text-sm hover:bg-background-50/30 transition-colors duration-200"
            >
              探索同人小说
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}